









































import Vue from 'vue'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { GridApi } from 'ag-grid-community'
import { GridOptions, SimpleWeekTimeModelDialog } from '@/types'
import { LOAD_EMPLOYEE_TIME_MODEL, UPDATE_DELETE_MASTER_DATA_SIMPLE_WEEK_TIME_MODEL } from '@/store/action-types'
import { EmployeeTimeModelPayload } from '@/types/payload'
import moment from 'moment'
import { hexToRgba } from '@/services/hex-to-rgba'
import TimeModelEditorDialog from '@/components/master-data/time-models/TimeModelEditorDialog.vue'
import { SimpleWeekTimeModel } from '@/model/master-data/SimpleWeekTimeModel'
import { KeyActionEnum, MasterDataActionsEnum, QcqOperations, SnackbarStateEnum } from '@/types/enums'
import { TranslateResult } from 'vue-i18n'
import { keyActionService } from '@/services/key-action-service'
import { KeyAction } from '@/model/KeyAction'

class Edit extends KeyAction {}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  gridData: Array<SimpleWeekTimeModel>
  gridOptions: GridOptions
  gridApi: GridApi | undefined
  overlayNoRowsTemplate: string
  selectedTimeModel: SimpleWeekTimeModel | undefined
  openDialog: boolean
  currentSelectedOperation: number
  isSubmitButtonDisabled: boolean
  isDeleteButtonDisabled: boolean
  timeModelDialogData: SimpleWeekTimeModelDialog | undefined

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'Capacity',

  components: {
    AgGridVue,
    TimeModelEditorDialog
  },

  props: {
    employeeId: Number
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      gridData: [],
      gridApi: undefined,
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('employeeFormComponent.capacity.name'), field: 'name', width: 200 },
          { headerName: this.$t('masterData.masterDataTimeModelsPage.type'), field: 'modelType', width: 100 },
          { headerName: this.$t('employeeFormComponent.capacity.from'), field: 'validFrom', width: 200 },
        ]
      },
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      selectedTimeModel: undefined,
      openDialog: false,
      currentSelectedOperation: QcqOperations.EDIT,
      isSubmitButtonDisabled: false,
      isDeleteButtonDisabled: true,
      timeModelDialogData: undefined,

      keyActions: []
    }
  },

  watch: {
    employeeId (newVal: Number): void {
      if (newVal) {
        this.clearSort()
        this.gridData = []
        // noinspection JSIgnoredPromiseFromCall
        this.loadTimeModelData()
      }
    },
  },

  computed: {
    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isEditDisabled (): boolean {
      return !(this.selectedTimeModel && this.selectedTimeModel.modelType === 'S')
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Edit | null): boolean {
      if(action instanceof Edit) {
        return this.isEditDisabled
      } else {
        return false
      }
    },

    async loadTimeModelData (): Promise<void> {
      const payload: EmployeeTimeModelPayload = {
        date: moment().format('YYYY-MM-DD'),
        name: '',
        employee: this.employeeId,
      }
      try {
        const data: Array<SimpleWeekTimeModel> = await this.$store.dispatch(LOAD_EMPLOYEE_TIME_MODEL, payload)
        if (data) {
          this.gridData = data
        }
      } catch (e) {
        this.messageSnackbar = this.$t('employeeFormComponent.capacity.dataCouldNotBeLoaded')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    clearSort () {
      if (this.gridApi) {
        this.gridApi.setSortModel(null)
      }
    },

    onRowClicked (params: any) {
      this.selectedTimeModel = params.node.data
    },

    onEditButtonClick (): void {
      this.currentSelectedOperation = QcqOperations.EDIT
      this.timeModelDialogData = {
        timestamp: new Date().getTime(),
        operation: this.currentSelectedOperation,
        timeModel: this.selectedTimeModel
      }
      this.openDialog = true
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onEditButtonClick()
    },

    closeDialog (): void {
      this.openDialog = false
      this.currentSelectedOperation = QcqOperations.EDIT
      this.selectedTimeModel = undefined
      this.timeModelDialogData = undefined
    },

    async onSaveDialog (timeModel: undefined | SimpleWeekTimeModel): Promise<void> {
      this.isSubmitButtonDisabled = true
      try {
        if (timeModel) {
          const map = new Map([
            [QcqOperations.ADD, MasterDataActionsEnum.Create],
            [QcqOperations.EDIT, MasterDataActionsEnum.Update],
            [QcqOperations.REMOVE, MasterDataActionsEnum.Delete]
          ])
          await this.$store.dispatch(UPDATE_DELETE_MASTER_DATA_SIMPLE_WEEK_TIME_MODEL, {
            action: map.get(this.currentSelectedOperation),
            timeModel: timeModel
          })
          this.closeDialog()
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.isSubmitButtonDisabled = false
          this.selectedTimeModel = undefined
          await this.loadTimeModelData()
        }
      } catch (e) {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
        this.isSubmitButtonDisabled = false
      }
    }

  },

  beforeMount () {
    this.keyActions = [
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
    ]
    // noinspection JSIgnoredPromiseFromCall
    this.loadTimeModelData()
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)
    this.gridApi = this.gridOptions.api
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
